import {
    CoreFetch,
    ListSupportTagsOrderEnum,
    SupportTag,
    SupportTagSortType,
    TagApi,
} from '../../api';
import { FilterMethod, ICustomFilter } from '../../ui/data-table/components/filters/filters.models';
import { createRequestFilters } from '../../ui/data-table/data-table.service';

const TAG_SEARCH_LIMIT = 100;

export interface WorkflowTagOption {
    name: string;
}

function toTagOption(tag: SupportTag): WorkflowTagOption | null {
    const name = tag.name?.trim();
    if (!name) {
        return null;
    }

    return { name };
}

/** Searches active support tags by name via GET /support/tag. */
export async function searchSupportTags(query: string): Promise<WorkflowTagOption[]> {
    const term = query.trim();
    const filters: ICustomFilter[] = term
        ? [
              {
                  filterId: 'filterName',
                  filterMethod: FilterMethod.LK,
                  filterType: 'String',
                  value: term,
              },
          ]
        : [];

    const tags = await CoreFetch<TagApi>(TagApi).listSupportTags({
        limit: TAG_SEARCH_LIMIT,
        sort: [SupportTagSortType.NAME],
        order: [ListSupportTagsOrderEnum.ASCENDING],
        filterActive: 'EQ:1',
        ...createRequestFilters(filters, true),
    });

    const seen = new Set<string>();
    const options: WorkflowTagOption[] = [];

    for (const tag of tags) {
        const option = toTagOption(tag);
        if (!option || seen.has(option.name)) {
            continue;
        }

        seen.add(option.name);
        options.push(option);
    }

    return options;
}
